<div class="d-flex flex-column mx-3 mt-4">
  <div class="d-flex justify-content-between">
    <div class="form-check form-switch">
      <!-- <input #val [id]="label" [class]="additionalCssClasses" class="form-check-input" type="checkbox" role="switch" [value]="value"> -->
      <ng-content></ng-content>
      <label class="form-check-label ms-2" [for]="label">{{label}}</label>
    </div>
  </div>
</div>
